import React from 'react';

import { useStyle } from '@/classify';
import defaultClasses from './errorMessage.module.css';

const ErrorMessage = React.forwardRef((props, ref) => {
  const { children } = props;

  const classes = useStyle(defaultClasses, props.classes);

  return (
    <div
      className={classes.root}
      ref={ref}
    >
      <span className={classes.errorMessage}>{children}</span>
    </div>
  );
});

export default ErrorMessage;
